import { render, staticRenderFns } from "./SubRow.vue?vue&type=template&id=765ee22c&scoped=true&"
import script from "./SubRow.vue?vue&type=script&lang=ts&"
export * from "./SubRow.vue?vue&type=script&lang=ts&"
import style0 from "./SubRow.vue?vue&type=style&index=0&id=765ee22c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "765ee22c",
  null
  
)

export default component.exports